import auth from "../../middlewares/auth";
export const settingsChapterRoute = [
  {
    path: '/settings/chapter',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/chapter/ChapterList'),
    name: 'settings_chapter',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/chapter/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/chapter/ChapterForm'),
    name: 'settings_chapter_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/chapter/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/chapter/ChapterForm'),
    name: 'settings_chapter_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];